import { render } from "./VanguardDescription.vue?vue&type=template&id=fd3ed78e"
import script from "./VanguardDescription.vue?vue&type=script&lang=js"
export * from "./VanguardDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__